import DatePicker from "../Datepicker/datepicker.js";
import FilterPicker from "../Filter/filterpicker.js";

export default (el) => {
    var Filter = function (renderTo, renderToEl, url, filterOptions) {
        this.historyApiAvailable = (window.history && history.pushState);

        this._renderTo = renderTo;
        this._renderToEl = renderToEl;
        this._url = url;
        this._filterOptions = filterOptions || [];

        this._xhr = null;
        this._skipXhr = false;

        this.datePicker = new DatePicker();

        this.filterPicker = new FilterPicker();

        this.onFilterFormSubmitBound = this.onFilterFormSubmit.bind(this);
        this.onFilterableChangeBound = this.onFilterableChange.bind(this);
        this.onCategoryToggleClickedBound = this.onCategoryToggleClicked.bind(this);
        this.onFilterSelectionItemClickedBound = this.onFilterSelectionItemClicked.bind(this);
        this.onDocumentClickBound = this.onDocumentClick.bind(this);
        this.onFilterClearBound = this.onFilterClear.bind(this);

        document.addEventListener('click', this.onDocumentClickBound, false);

        this.attachListeners();
    };

    Filter.prototype.attachListeners = function () {
        this.attachFilterListeners();

        if (!this.historyApiAvailable) {
            return;
        }

        var form = this._renderToEl.querySelector('form.filter-form');
        form.addEventListener('submit', this.onFilterFormSubmitBound, false);
    };

    Filter.prototype.attachFilterListeners = function () {
        var filterInputs = this._renderToEl.querySelectorAll('.filterable input, .filterable select');
        filterInputs.forEach(function (input, i) {
            input.addEventListener('change', this.onFilterableChangeBound, false);
        }, this);

        var categoryTitles = this._renderToEl.querySelectorAll('.js-filter-category-toggle');
        categoryTitles.forEach(function (title, i) {
            title.addEventListener('click', this.onCategoryToggleClickedBound, false);
        }, this);

        var filterSelectionItems = this._renderToEl.querySelectorAll('.js-filter-selection-item');
        filterSelectionItems.forEach(function (selectedItem, i) {
            selectedItem.addEventListener('click', this.onFilterSelectionItemClickedBound, false);
        }, this);

        var filterClear = this._renderToEl.querySelector('.filter-selection__clear');
        if (filterClear) {
            filterClear.addEventListener('click', this.onFilterClearBound, false);
        }

        var datePicker = this._renderToEl.querySelector('.js-date-picker');
        this.datePicker.detach();
        this.datePicker.attach(datePicker);

        var filterPicker = this._renderToEl.querySelector('.js-filter-picker');
        this.filterPicker.detach();
        this.filterPicker.attach(filterPicker);
    };

    Filter.prototype.onCategoryToggleClicked = function (e) {
        e.preventDefault();

        var categoryElement = e.target;
        while (categoryElement instanceof HTMLElement && !categoryElement.classList.contains('js-filter-category')) {
            categoryElement = categoryElement.parentNode;
        }

        if (categoryElement) {
            this.setCategoryOpen(categoryElement.id, !categoryElement.classList.contains('-open'));
        }
    };

    Filter.prototype.onDocumentClick = function (e) {
        var insideCategory = false;

        var current = e.target;
        while (current instanceof HTMLElement) {
            if (current.classList.contains('js-filter-category-toggle') || current.classList.contains('js-filter-submit-trigger')) {
                insideCategory = true;
                break;
            }

            if (current.classList.contains('js-filter-category')) {
                insideCategory = true;
                break;
            }

            current = current.parentNode;
        }

        if (!insideCategory) {
            this.setCategoryOpen(null, false);
        }
    };

    Filter.prototype.onFilterClear = function (e) {
        e.preventDefault();

        var i, elements = document.querySelectorAll('.filterable input, .filterable select');
        for (i = elements.length - 1; i >= 0; i = i - 1) {
            elements[i].checked = false;
            elements[i].value = '';
        }
        this.submit();
    };

    Filter.prototype.setCategoryOpen = function (categoryId, isOpen) {
        var categories = this._renderToEl.querySelectorAll('.js-filter-category');
        categories.forEach(function (category, i) {
            if (categoryId === category.id && isOpen) {
                category.classList.add('-open');
            } else {
                category.classList.remove('-open');
            }

            var stateInputName = category.id + '_state';
            var stateInput = category.querySelector('[name=' + stateInputName + ']');
            if (stateInput) {
                stateInput.value = category.classList.contains('-open') ? 1 : 0;
            }
        }, this);
    };

    Filter.prototype.onFilterSelectionItemClicked = function (e) {
        e.preventDefault();

        var item = e.target;
        var id = item.getAttribute('data-id');
        var category = item.getAttribute('data-category');

        if (category === 'date') {
            this.datePicker.setValue(null);
        } else if (['audience', 'project', 'location', 'age'].includes(category)) {
            var select = this._renderToEl.querySelector('#' + id.substr(0, id.indexOf('_')));
            select.value = '';
        } else {
            var input = this._renderToEl.querySelector('#' + id);
            input.removeAttribute('checked');
        }

        this.submit();
    };

    Filter.prototype.onFilterFormSubmit = function (e) {
        if (this._skipXhr) {
            this._skipXhr = false;
            return;
        }

        e.preventDefault();

        this._renderToEl.querySelector('.filter-form').classList.add('-is-loading');

        var formData = this.serializeForm(e.target);

        if (this._xhr) {
            this._xhr.abort();
        }

        this._xhr = new XMLHttpRequest();
        this._xhr.addEventListener('load', this.onFormSubmitSuccess.bind(this, formData));
        this._xhr.open('GET', this._url + '?' + formData);
        this._xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        this._xhr.send();
    };

    Filter.prototype.onFormSubmitSuccess = function (formData) {
        this._renderToEl.innerHTML = this._xhr.responseText;
        window.history.replaceState(
            null,
            null,
            this._url + (this._url.indexOf('?') !== -1 ? formData : '?' + formData)
        );
        this.attachListeners();
    };

    Filter.prototype.onFilterableChange = function (e) {
        e.stopPropagation();
        this.submit();
    };

    Filter.prototype.submit = function () {
        document.querySelector('form .filter__submit').click();
    };

    Filter.prototype.serializeForm = function (form) {
        if (!form || form.nodeName !== "FORM") {
            return;
        }
        var i, j, q = [];
        for (i = form.elements.length - 1; i >= 0; i = i - 1) {
            if (form.elements[i].name === "") {
                continue;
            }
            switch (form.elements[i].nodeName) {
                case 'INPUT':
                    switch (form.elements[i].type) {
                        case 'text':
                        case 'hidden':
                        case 'password':
                        case 'button':
                        case 'reset':
                        case 'submit':
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            break;
                        case 'checkbox':
                        case 'radio':
                            if (form.elements[i].checked) {
                                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            }
                            break;
                        case 'file':
                            break;
                    }
                    break;
                case 'TEXTAREA':
                    q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                    break;
                case 'SELECT':
                    switch (form.elements[i].type) {
                        case 'select-one':
                            if (form.elements[i].value) {
                                q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            }
                            break;
                        case 'select-multiple':
                            for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                                if (form.elements[i].options[j].selected) {
                                    q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].options[j].value));
                                }
                            }
                            break;
                    }
                    break;
                case 'BUTTON':
                    switch (form.elements[i].type) {
                        case 'reset':
                        case 'submit':
                        case 'button':
                            q.push(form.elements[i].name + "=" + encodeURIComponent(form.elements[i].value));
                            break;
                    }
                    break;
            }
        }
        return q.join("&");
    };

    var filters = document.querySelectorAll('[data-component="Filter/filter"]');
    filters.forEach(function (element, id) {
        var data = element.querySelector('[data-component-config]');
        var setup = JSON.parse(data.innerHTML);
        new Filter(setup.renderTo, element, setup.url, setup.filterOptions || []);
    });
}
